import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { CategoryNaturalKey } from '../../documents';

export class ActivityReportsBuildPart extends BaseBuildPart {
    constructor(private readonly activityReportsHelperParams: HelperParams,
                parent: BaseBuildPart) {
        super(activityReportsHelperParams, parent, ['activity-reports']);
    }

    public documents(categoryId?: CategoryNaturalKey) {
        const paths = ['documents'];

        if (categoryId) {
            paths.push(categoryId);
        }

        return new BaseBuildPart(this.activityReportsHelperParams, this, paths);
    }

    public eReqReports(): BaseBuildPart {

        return new BaseBuildPart(this.activityReportsHelperParams, this, ['eReq-report']);
    }

    public protocolAccess() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['protocol-access']);
    }

    public accessInvestigation() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['access-investigation']);
    }

    public emailNotificationAlerts() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['email-alerts']);
    }
}